import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  showModal = false;
  constructor() { }

  setShowModal(param: boolean) {
    this.showModal = param;
  }

  getShowModal() {
    return this.showModal;
  }

}
